/** Safe parse for incident JSON blobs — avoids crash on "null", invalid JSON, or arrays. */
function parseIncidentJsonBlob(json?: string | null): Record<string, unknown> {
  try {
    const raw = JSON.parse(json || "{}");
    if (raw && typeof raw === "object" && !Array.isArray(raw)) {
      return raw as Record<string, unknown>;
    }
  } catch {
    /* ignore */
  }
  return {};
}

/** Safe parse for incident.supportJson — avoids crash when DB stores "null" or invalid JSON. */
export function parseIncidentSupport(supportJson?: string | null): Record<string, unknown> {
  return parseIncidentJsonBlob(supportJson);
}

/** Safe parse for incident.requiredJson (vehicle type counts). */
export function parseRequiredJson(requiredJson?: string | null): Record<string, number> {
  const raw = parseIncidentJsonBlob(requiredJson);
  const out: Record<string, number> = {};
  for (const [k, v] of Object.entries(raw)) {
    const n = Number(v);
    if (Number.isFinite(n) && n > 0) out[k] = n;
  }
  return out;
}
